// ============ PROFILE TYPES ============
export interface CompatibilityProfile {
  name: string;
  age: number;
  gender: 'Male' | 'Female' | 'Other' | 'Prefer not to say';
  city: string;
  birthDate: string;
  lookingFor: string[];
  lookingForOther?: string;
  personalityType: 'Introvert' | 'Extrovert' | 'Ambivert';
  communicationStyle: 'Direct' | 'Soft' | 'Playful';
  interests: string[];
  interestsOther?: string;
  values: {
    honesty: number;
    loyalty: number;
    senseOfHumor: number;
    ambition: number;
    kindness: number;
    intelligence: number;
    physicalAttraction: number;
  };
  bio?: string;
}

export interface FormData {
  name: string;
  age: string;
  gender: 'Male' | 'Female' | 'Other' | 'Prefer not to say';
  city: string;
  birthDate: string;
  lookingFor: string[];
  lookingForOther: string;
  personalityType: 'Introvert' | 'Extrovert' | 'Ambivert';
  communicationStyle: 'Direct' | 'Soft' | 'Playful';
  interests: string[];
  interestsOther: string;
  values: {
    honesty: number;
    loyalty: number;
    senseOfHumor: number;
    ambition: number;
    kindness: number;
    intelligence: number;
    physicalAttraction: number;
  };
  bio: string;
}

export interface MatchUser {
  _id: string;
  username: string;
  email: string;
}

export interface MatchItem {
  userId: MatchUser;
  matchScore: number;
  matchDetails: {
    ageCompatibility: string;
    interestsMatch: number;
    personalityMatch: string;
    valuesMatch: number;
    communicationMatch: string;
  };
  connectionStatus: 'none' | 'pending' | 'accepted' | 'rejected';
  requestId: string | null;
}

export interface ConnectionRequest {
  _id: string;
  otherUser: MatchUser;
  status: 'pending' | 'accepted' | 'rejected' | 'expired';
  message?: string;
  isSender: boolean;
  createdAt: string;
  respondedAt?: string;
}

export interface SynastryTheme {
  id: string;
  label: string;
  score: number;
  summary: string;
  strengths: string[];
  frictions: string[];
  guidance: string[];
}

export interface SynastryReport {
  overallScore: number;
  themes: SynastryTheme[];
  bestTimeToTalk: string | null;
}

export interface ChatMessage {
  _id: string;
  connectionRequestId: string;
  senderId: string;
  text: string;
  createdAt: string;
}

// ============ CONSTANTS ============
export const INITIAL_FORM_DATA: FormData = {
  name: '',
  age: '',
  gender: 'Male',
  city: '',
  birthDate: '',
  lookingFor: [],
  lookingForOther: '',
  personalityType: 'Ambivert',
  communicationStyle: 'Soft',
  interests: [],
  interestsOther: '',
  values: {
    honesty: 3,
    loyalty: 3,
    senseOfHumor: 3,
    ambition: 3,
    kindness: 3,
    intelligence: 3,
    physicalAttraction: 3,
  },
  bio: '',
};

export const LOOKING_FOR = [
  'Friendship',
  'Relationship/Dating',
  'Business Partnership',
  'Travel Buddy',
  'Study Partner',
  'Just Chat/Meet New People',
  'Other',
];

export const INTERESTS = [
  'Music', 'Travel', 'Food', 'Sports', 'Art',
  'Technology', 'Books', 'Movies', 'Nature',
  'Fitness', 'Gaming', 'Other',
];

export const PERSONALITY_TYPES: FormData['personalityType'][] = ['Introvert', 'Extrovert', 'Ambivert'];
export const COMMUNICATION_STYLES: FormData['communicationStyle'][] = ['Direct', 'Soft', 'Playful'];
export const GENDER_OPTIONS: FormData['gender'][] = ['Male', 'Female', 'Other', 'Prefer not to say'];

export const VALUE_LABELS: Record<string, string> = {
  honesty: 'Honesty',
  loyalty: 'Loyalty',
  senseOfHumor: 'Sense of Humor',
  ambition: 'Ambition',
  kindness: 'Kindness',
  intelligence: 'Intelligence',
  physicalAttraction: 'Physical Attraction',
};
